<template>
    <div class="sector">
        <button @click="goToSector(sector.id)" class="sector-btn" v-for="sector in sectors" :key="sector.id">
            <img
                v-if="sector.file && sector.file.thumbnail"
                :src="`/files-thumb/${sector.file.thumbnail}`"
                :alt="sector[`keyword_${currentLanguage}`] ? sector[`keyword_${currentLanguage}`] : sector[`title_${currentLanguage}`]"
            />
            <img v-else />
            <p>{{ sector[`title_${currentLanguage}`] || sector[`title_en`] }}</p>
        </button>
    </div>
</template>

<script>

import axios from 'axios';

export default {
    mounted() {
        axios.get(`/pa/sectors?with=file`).then(resp => {
            this.sectors = resp.data.data;
        });
    },
    computed: {
        currentLanguage() {
            var lang = window.location.pathname.split('/')[1];
            switch (lang) {
                case 'hu':
                    return lang;
                    break;
                case 'en':
                    return lang;
                    break;
                case 'de':
                    return lang;
                    break;
                default:
                    return 'en';
            }
        },
    },
    methods: {
        getLanguage() {
            var lang = window.location.pathname.split('/')[1];
            switch (lang) {
                case 'hu':
                    return lang;
                case 'en':
                    return lang;
                case 'de':
                    return lang;
                default:
                    return 'en';
            }
        },
        goToSector(id) {
            this.$router.push({
                name: "projects-filter",
                params: { lang: this.currentLanguage }, 
                query: { sector_id: id }
            });

        },
    },
    data() {
        return {
            sectors: [],
        };
    },
};
</script>

<style lang="scss">
@import './../../sass/mixins';
@import './../../sass/variables';

.sector {
    @media screen and (max-width: $mobile-max) {
        text-align: center;
    }
}
.sector-btn {
    margin: 15px;
    height: 260px;
    width: 260px;
    justify-content: space-between;
    overflow: hidden;
    border: none;
    position: relative;
    padding: 0;

    &:hover {
        transform: scale(1.1);
        transition: transform 800ms;

        // &:after {
        // 	transition: all 800ms;
        // 	opacity: 0;
        // }
    }

    &:after {
        $start-gradient-color: rgba(51, 198, 244, 1);
        $end-gradient-color: rgba(51, 198, 244, 0);
        transition: all 800ms;
        background-image: linear-gradient(0deg, $start-gradient-color 15%, $end-gradient-color 30%);
        position: absolute;
        display: block;
        opacity: 0.9;
        height: 100%;
        content: '';
        width: 100%;
        left: 0;
        top: 0;
    }
}
.sector-btn img {
    height: 100%;
    width: 100%;
}

.sector-btn p {
    position: absolute;
    bottom: 10px;
    margin: 0 5px;
    color: white;
    text-shadow: 1px 1px 4px #244472;
    z-index: 2;
}
</style>
